<template>
  <vs-popup
    class="mission-modal"
    :title="title || 'اختر مهمة الاستلام'"
    :active="active"
    @update:active="onUpdateActive"
  >
    <div>
      <p class="mb-4">
        {{ message || `سيتم إضافة ${selectedOrders.length} طلب للمهمة` }}
      </p>
      <v-select
        v-model="selectedMissionId"
        class="w-full mb-4"
        :options="availableMissions"
        :filterable="false"
        @search="onMissionSearch"
        @open="onMissionOpen"
        label="code"
        :reduce="mission => mission.id"
        :loading="loadingMissions"
        placeholder="اختر مهمة"
      >
        <template slot="option" slot-scope="option">
          <div class="d-center">
            {{ option.code }} - {{ option.status_text }}
          </div>
        </template>
        <template slot="selected-option" slot-scope="option">
          <div class="d-center">
            {{ option.code }} - {{ option.status_text }}
          </div>
        </template>
        <template #list-footer>
          <div v-show="hasNextPage" class="w-full text-center">
            <vs-button @click="loadMoreMissions" type="flat" :disabled="loadingMissions">
              تحميل المزيد
            </vs-button>
          </div>
        </template>
      </v-select>

      <div class="flex justify-end">
        <vs-button
          @click="confirmAction"
          color="primary"
          class="mr-3"
          type="filled"
          :disabled="!selectedMissionId || actionLoading"
          :loading="actionLoading"
        >
          {{ confirmText || 'تأكيد' }}
        </vs-button>
        <vs-button @click="closeModal" color="danger" type="border">إلغاء</vs-button>
      </div>
    </div>
  </vs-popup>
</template>

<script>
import axios from 'axios'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'

export default {
  name: 'MissionModal',
  components: {
    vSelect
  },
  props: {
    active: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    message: {
      type: String,
      required: true
    },
    confirmText: {
      type: String,
      required: true
    },
    selectedOrders: {
      type: Array,
      required: true
    },
    actionLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedMissionId: null,
      availableMissions: [],
      missionPage: 1,
      missionSearchQuery: '',
      hasNextPage: false,
      loadingMissions: false
    }
  },
  watch: {
    active: {
      handler(newVal) {
        if (newVal) {
          this.resetModal()
          this.fetchMissions()
        }
      },
      immediate: true
    }
  },
  methods: {
    onUpdateActive(val) {
      // Propagate close when user clicks overlay/close icon on popup
      if (!val) this.closeModal()
    },
    resetModal() {
      this.selectedMissionId = null
      this.availableMissions = []
      this.missionPage = 1
      this.missionSearchQuery = ''
      this.hasNextPage = false
    },
    onMissionOpen() {
      if (!this.availableMissions.length) {
        this.fetchMissions()
      }
    },
    onMissionSearch(search) {
      this.missionSearchQuery = search
      this.missionPage = 1
      this.availableMissions = []
      this.fetchMissions()
    },
    async fetchMissions() {
      this.loadingMissions = true
      try {
        const { data } = await axios.get('mission/pickup/new-missions', {
          params: {
            page: this.missionPage,
            search: this.missionSearchQuery
          }
        })

        if (data.success) {
          if (this.missionPage === 1) {
            this.availableMissions = data.feed
          } else {
            this.availableMissions.push(...data.feed)
          }

          this.hasNextPage = data.meta.current_page < data.meta.last_page
        }
      } finally {
        this.loadingMissions = false
      }
    },
    loadMoreMissions() {
      this.missionPage++
      this.fetchMissions()
    },
    confirmAction() {
      if (!this.selectedMissionId) return
      this.$emit('confirm', this.selectedMissionId)
    },
    closeModal() {
      this.$emit('close')
      this.resetModal()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/vuexy/_variables.scss';

.mission-modal {
  .vs-popup {
    max-width: 500px;
  }

  .selected {
    background-color: rgba(49, 0, 111, 0.1);
    padding: 4px 8px;
    border-radius: 4px;
  }
}
</style>
